import request from '@/utils/request';

const serverUrl = process.env.VUE_APP_BASE_API;

const common = {
  tc(params) {
    return request({
      url: `${serverUrl}/tc/list`,
      method: 'GET',
      params,
    });
  },

  // 查询所有机场列表
  findAllAirport(data) {
    return request({
      url: `${serverUrl}/visa/latam/trafficsite/findAll`,
      method: 'POST',
      data,
    });
  },

  // 首页数据获取
  getHomePageBanner(data) {
    return request({
      url: `${serverUrl}/visa/latam/offers/benefit/show/list`,
      method: 'POST',
      data,
    });
  },

  // 获取首页头部banner图
  getHomePageHeadBanner(data) {
    return request({
      url: `${serverUrl}/visa/latam/offers/benefit/banner`,
      method: 'POST',
      data,
    });
  },

  // 首页权益数据
  getHomePageData(data) {
    const { userId, sessionId, ...params } = data;
    const formData = new FormData();
    if (userId) formData.append('userId', userId);
    if (sessionId) formData.append('sessionId', sessionId);

    return request({
      url: `${serverUrl}/visa/latam/web/benefit/home`,
      method: 'POST',
      params,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 根据条件查询列表
  getListByCondition(data, userId, sessionId, lang) {
    return request({
      url: `${serverUrl}/visa/latam/offers/benefit/getListByCondition`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: { ...data, lang, userId, sessionId },
    });
  },

  // 获取过滤条件
  getFilterCondition(data) {
    return request({
      url: `${serverUrl}/visa/latam/offers/benefit/getFilter`,
      method: 'POST',
      data,
    });
  },

  // 获取分类
  getCategory(data) {
    return request({
      url: `${serverUrl}/visa/latam/offers/benefit/getCategory`,
      method: 'POST',
      data,
    });
  },

  // 获取T&C内容
  getServiceContent(data) {
    return request({
      url: `${serverUrl}/visa/latam/tc`,
      method: 'POST',
      data,
    });
  },

  // 获取FAQ内容
  getFAQContent(data) {
    return request({
      url: `${serverUrl}/visa/latam/question/list`,
      method: 'POST',
      data,
    });
  },

  encryptPublicKey(data) {
    return request({
      url: `${serverUrl}/visa/card/vces/encryptPublicKey`,
      method: 'POST',
      data,
    });
  },

  // 获取消息通知列表
  getNotificationList(data) {
    return request({
      url: `${serverUrl}/visa/latam/notification/listV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  getRecaptch(data) {
    return request({
      url: `${serverUrl}/visa/latam/captcha/getConfig`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 更新已读状态
  updateNotificationStatus(params) {
    return request({
      url: `${serverUrl}/visa/latam/notification/updateReadStatus`,
      method: 'POST',
      params,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  generateSasToken(data) {
    return request({
      url: `${serverUrl}/visa/latam/azure/generateSasTokenByFileName`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  getUploadConfig(data) {
    return request({
      url: `${serverUrl}/visa/latam/azure/getUploadConfig`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  verifyRecaptcha(data) {
    return request({
      url: `${serverUrl}/visa/latam/captcha/verifyRecaptcha`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  getProjectSubjectList(data) {
    return request({
      url: `${serverUrl}/visa/latam/feedBack/getProjectSubjectList`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  freshDeskSubmit(data) {
    return request({
      url: `${serverUrl}/visa/latam/feedBack/submitV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
};

export default common;
